import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    Button,
    Grid,
    Container,
} from "@mui/material";
import { useMediaQueries } from "../../usecontext/UseProvider";
import { getAboutGallery } from "../../services/AboutGallery";
import { useNavigate } from "react-router-dom";

const TransformHouse = () => {
    const { isSmallScreen } = useMediaQueries();
    const [aboutGalleryData, setAboutGalleryData] = useState([])
    const navigate = useNavigate();

    const getAboutGalleryData = async () => {
        try {
            const response = await getAboutGallery();
            setAboutGalleryData(response?.aboutGalleryData);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getAboutGalleryData();
    }, []);

    return (
        <Box sx={{ backgroundColor: "#212529", }}>
            <Container
                sx={{
                    color: "#fff",
                    py: { lg: 6, xs: 3 },
                }}
            >
                <Grid container spacing={4} alignItems="center">
                    <Grid item xs={12} md={6} data-aos="fade-right">
                        <Typography
                            variant={"h4"}
                            sx={{ fontWeight: "bold", marginBottom: 5, color: '#fff' }}
                        >
                            {aboutGalleryData?.title}
                        </Typography>
                        {aboutGalleryData?.description?.map((item, index) => (
                            <Typography
                                variant={"body1"}
                                sx={{ fontSize: "22px", color: '#fff' }}
                                key={index}
                            >
                                {item}
                            </Typography>
                        ))}
                        <Button
                            data-aos="fade-up"
                            data-aos-delay="400"
                            variant="varient"
                            size={isSmallScreen ? 'small' : 'medium'}
                            sx={{
                                fontWeight: 400,
                                borderColor: '#fff',
                                backgroundColor: '#01A0E2',
                                color: '#fff',
                                borderRadius: '0',
                                mt: { md: 4, xs: 0 },
                                px: { md: 6 },
                                height: '44px',
                                fontSize: { md: '20px' }
                            }}
                            onClick={() => navigate("/contactus")}>
                            Discover more
                        </Button>
                    </Grid>

                    <Grid item xs={12} md={6} textAlign="center" data-aos="fade-left">
                        <Grid container spacing={2} justifyContent="center">
                            {aboutGalleryData?.images?.map((image, index) => (
                                <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={6}
                                    key={index}
                                    data-aos="zoom-in"
                                    data-aos-delay={index * 100}
                                >
                                    <Box
                                        component="img"
                                        src={image?.url}
                                        alt={`Swing ${index + 1}`}
                                        sx={{
                                            width: "100%",
                                            height: "240px",
                                            objectFit: "cover",
                                        }}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default TransformHouse;